import axios, { AxiosTransformer } from 'axios';
import { User } from 'oidc-client';
import { getUserManager } from '@axa-fr/react-oidc-context';

const FaraGostarHttp = async () => {
    const um = await getUserManager().getUser() as User;
    const token = um.access_token;

    let headers = null;
    if (token) {
        headers = {
            Authorization: `Bearer ${token}`,
        };
    }

    const instance = axios.create({
        baseURL: window.config.apiUrl,
        headers,
    });

    return instance;
};

export default FaraGostarHttp;